<template>
  <div class="content">
    <slot/>
  </div>
</template>

<script>
export default {
  name: "MainContent"
};
</script>

<style scoped>
.content {
  display: flex;
  flex: 1;
  flex-flow: row wrap;
  width: 100%;
  height: 100%;
}
</style>

